import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import { stages } from "../../utils/constants";

import moreVertical from "../../assets/images/more-vertical.svg";

import ReviewAlert from "../Review/ReviewAlert";

import OtAction from "../OtAction/OtAction";
import { isPending } from "../../libs/helpers";
import AssistantProfileCard from "../AssistantProfileCard/AssistantProfileCard";
import ProfileShare from "../AssistantProfile/ProfileShare";

// nested menu
import { ReactComponent as RefreshIcon } from "../../assets/images/refresh.svg";
import { ReactComponent as ListIcon } from "../../assets/images/list.svg";
import { ReactComponent as StarIcon } from "../../assets/images/star-menu.svg";
import { ReactComponent as StopAssistantWorkIcon } from "../../assets/images/navbar/stop-assistant-work.svg";

// We only want to show the dropdown once the plan is confirmed
// TODO: in the future, there will be a different menu for pending hires
const showDropDown = (assistantPlan) => {
  return !(
    assistantPlan &&
    assistantPlan.is_instant_hire &&
    assistantPlan.status === stages.PENDING
  );
};

const Menu = ({ assistant }) => (
  <div className="dropdown position-absolute more-vertical">
    <div className="d-flex">
      <ProfileShare profile={assistant} />
      {showDropDown(assistant) && (
        <img
          className="pl-2 dropdown-toggle"
          src={moreVertical}
          alt=""
          role="button"
          data-toggle="dropdown"
        />
      )}
      <div className="dropdown-menu dropdown-menu-right assistant-menu">
        <Link className="dropdown-item" to={`/plan/${assistant.plan_id}`}>
          <ListIcon className="mr-3 with-stroke" />
          Plan Details
        </Link>
        <Link className="dropdown-item" to={`/feedbacks/${assistant.user_id || assistant.email}`}>
          <StarIcon className="mr-3" />
          Feedback History
        </Link>
        <a
          className="dropdown-item"
          data-testid="ChangeAssistant"
          href="mailto:client@getmagicnow.com?subject=Change%20Dedicated%20Assistant"
        >
          <RefreshIcon className="mr-3" />
          Change Assistant
        </a>
        <Link
          className="dropdown-item"
          data-testid="CancelAssistant"
          to={`/stop-assistant-work?plan_id=${assistant.plan_id}`}
        >
          <StopAssistantWorkIcon className="mr-3" />
          Stop Assistant Work
        </Link>
      </div>
    </div>
  </div>
);

const AssistantCard = ({ assistant, client, otRequest, history, showReviewForm }) => {
  const [hasOt, setHasOt] = useState(true);
  const { status } = assistant;

  const onCloseOtRequest = (status) => {
    toast.success(`Extra hours for ${assistant.name} ${status.toLowerCase()}!`);
    setHasOt(false);
  };

  const assistantAlerts = (status === stages.HIRED) && (
    <>
      {hasOt && otRequest && (
        <OtAction ot={otRequest} assistant={assistant} onClose={onCloseOtRequest} />
      )}
      <ReviewAlert assistant={assistant} showReviewForm={showReviewForm} />
    </>
  );

  const top = (
    <>
      <Menu assistant={assistant} />
      {assistantAlerts}
    </>
  )

  return (
    <div data-testid="AssistantCard">
      <AssistantProfileCard
        assistant={assistant}
        client={client}
        ribbonContent={isPending(assistant) && "Pending"}
        top={top}
        expandable
        startExpanded={false}
        history={history}
        feedbackUrl={`/feedbacks/${assistant.user_id || assistant.email}`}/>
    </div>
  );
};

export default AssistantCard;
